import Grid from '@mui/material/GridLegacy';


const Totals = ({ data }) => {

    const currency = (amount) => {
        if (amount < 0) {
            amount = amount.substring(1);
            amount = "- £" + parseFloat(amount).toFixed(2);
        } else {
            amount = "£" + parseFloat(amount).toFixed(2);
        }
        return amount;
    };

    const subtotalLeftStyle = {
        fontWeight: "bold",
        textAlign: "left",
    };
    const subtotalRightStyle = {
        fontWeight: "bold",
        textAlign: "right",
    };
    const surchargeLeftStyle = {
        fontWeight: "normal",
        textAlign: "left",
    };
    const addressCardStyle = {
        margin: "5px auto",
        textAlign: "center",
        maxWidth: "450px",
    };
    const surchargeRightStyle = {
        fontWeight: "bold",
        textAlign: "right",
    };


    const subtotalStyle = { padding: "15px" };

    return (
        <div style={subtotalStyle}>

            <Grid container>
                <Grid item xs={6}>
                    <p style={surchargeLeftStyle}>Total Cost (ex. VAT) :</p>
                </Grid>
                <Grid item xs={6}>
                    <p style={surchargeRightStyle}>
                        {
                            currency(
                                data.details
                                    .TotalCost
                            )
                        }
                    </p>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={6}>
                    <p style={surchargeLeftStyle}>VAT :</p>
                </Grid>
                <Grid item xs={6}>
                    <p style={surchargeRightStyle}>
                        {
                            currency(
                                data.details
                                    .VATAmount
                            )
                        }
                    </p>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={6}>
                    <p style={surchargeLeftStyle}>Total Cost (inc. VAT) :</p>
                </Grid>
                <Grid item xs={6}>
                    <p style={surchargeRightStyle}>
                        {
                            currency(
                                data.details
                                    .payment_amount
                            )
                        }
                    </p>
                </Grid>
            </Grid>

        </div>
    )
}

export default Totals